import template from "./instructor-edit-contact-info.html";
import InstructorEditController from "./instructor-edit-contact-info.controller";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.instructor.dashboard.edit", {
    url: "/edit",
    controller: InstructorEditController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.owner,
        USER_ROLES.instructor,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("instructor.dashboard.edit", [])
  .config(config)
  .controller("InstructorEditController", InstructorEditController);
